import { faFileArrowDown } from "@fortawesome/pro-solid-svg-icons"
import { Typography } from "@mui/material"
import { translate } from "app/language/service"
import { generateAndDownloadCampaignsCsvFile } from "campaign/tools/csv"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { LinearLoader } from "ui/components/LinearLoader"
import { PageHeader } from "ui/components/main-layout/PageHeader"
import { MyCampaignFilters } from "../filters/MyCampaignFilters"
import { MyForecastFilters } from "../filters/MyForecastFilters"
import { MySspDealFilters } from "../filters/MySspDealFilters"
import { CampaignList } from "../list/CampaignList"
import { DspDealList } from "../list/DspDealList"
import { ForecastList } from "../list/ForecastList"

interface IMyCampaignItemsPageProps {
  isLoading: boolean
  hasLoadingError: boolean
  isForecast: boolean
  isDspDeal: boolean
}

export const MyCampaignItemsPage = React.memo(
  ({ isLoading, hasLoadingError, isForecast, isDspDeal }: IMyCampaignItemsPageProps): JSX.Element => {
    const [isExporting, setIsExporting] = React.useState(false)
    return (
      <FlexBox vertical fullWidth fullHeight ai="start" jc="start" sx={{ animation: "fadeIn 600ms" }}>
        <PageHeader
          title={translate(isForecast ? "forecasts.title" : isDspDeal ? "dsp-deals.title" : "campaigns.title")}
          actionButtons={[
            {
              label: translate("label.export.csv"),
              disabled: isExporting,
              icon: faFileArrowDown,
              onClick: () => {
                setIsExporting(true)
                generateAndDownloadCampaignsCsvFile(isForecast, isDspDeal).finally(() => setIsExporting(false))
              }
            }
          ]}
        />
        <FlexBox
          fullWidth
          fullHeight
          jc="start"
          ai="start"
          vertical
          sx={{
            p: "1rem",
            pt: 0
          }}>
          {isLoading ? (
            <LinearLoader
              text={translate(isForecast ? "forecast.loading" : isDspDeal ? "dsp-deal.loading" : "campaign.loading")}
              sx={{ mt: "2rem" }}
            />
          ) : hasLoadingError ? (
            <Typography
              sx={{
                fontSize: "1.2rem",
                fontWeight: 500,
                mt: "1.5rem",
                mb: "1rem",
                color: theme => theme.palette.error.main
              }}>
              {translate(
                isForecast ? "forecast.loading.error" : isDspDeal ? "dsp-deal.loading.error" : "campaign.loading.error"
              )}
            </Typography>
          ) : (
            <>
              {isForecast ? <MyForecastFilters /> : isDspDeal ? <MySspDealFilters /> : <MyCampaignFilters />}
              <Typography
                id="my-campaign-items-page-title"
                sx={{
                  fontSize: "1.2rem",
                  fontWeight: 500,
                  mt: "1.5rem",
                  mb: "1rem",
                  color: theme => theme.palette.text.primary2
                }}>
                {translate(isForecast ? "forecast.my.title" : isDspDeal ? "dsp-deal.my.title" : "campaign.my.title")}
              </Typography>
              {isForecast ? <ForecastList /> : isDspDeal ? <DspDealList /> : <CampaignList />}
            </>
          )}
        </FlexBox>
      </FlexBox>
    )
  }
)
